import template from './am-operator-create.html';
class AmOperatorCreateController {
  constructor(amOperatorsService, amStoreService, $state) {
    'ngInject';
    this.opService = amOperatorsService;
    this.store = amStoreService;
    this.$state = $state;
    this.status = '';
    this.operatorName = '';
    this.autoPin = false;
    this.attrs = {};
    this.codes = [];
    this.createdOperator = null;
  }
  $onInit() {}
  $onChanges() {}
  $onDestroy() {}

  createOperater() {
    if (!this.operatorName) return;
    //show warning popup if user try to save with no codes
    if (!this.autoPin && this.codes.length < 1) {
      this.opService
        .openNoCodeWarningPopup()
        .then(() => {
          this.saveOperator();
        })
        .catch(() => {});
    } else {
      this.saveOperator();
    }
  }
  saveOperator() {
    const operator = {
      name: this.operatorName,
      attrs: this.attrs,
      autoGeneratePIN: this.autoPin,
      accessCodes: this.codes
    };
    this.status = 'creating';
    this.opService
      .createOperator(operator)
      .then(created => {
        this.createdOperator = created;
        this.autoPin = false;
        this.status = 'success';
      })
      .catch(error => {
        this.errorCode = error.status;
        this.status = 'error';
      });
  }
  resetForNewOperator() {
    this.status = '';
    this.operatorName = '';
    this.autoPin = false;
    this.attrs = {};
    this.codes = [];
    this.createdOperator = null;
  }
  goToDetails() {
    if (this.createdOperator && this.createdOperator.id) {
      this.$state.go('access-management.operator-view', {
        id: this.createdOperator.id,
        name: this.createdOperator.name
      });
    }
  }
  goToList() {
    this.$state.go('access-management.operators-list');
  }
}

export default {
  template,
  controller: AmOperatorCreateController,
  controllerAs: 'opCreateVm',
  bindings: {}
};
